/**
 * AccountAvatar — rounded square badge with institution initials.
 * Colour is looked up from INSTITUTION_COLOURS; falls back to evergreen.
 */
import React from 'react';
import { INSTITUTION_COLOURS } from '@/lib/accountsDemo';

function initials(name = '') {
  return name.split(' ').filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase();
}

export default function AccountAvatar({ account, size = 'md' }) {
  const c = INSTITUTION_COLOURS[account?.institution] || { bg: '#163A32', fg: '#A8C3B0' };
  const sizeCls =
    size === 'lg' ? 'w-12 h-12 text-sm' :
    size === 'sm' ? 'w-7 h-7 text-[10px]' :
    'w-9 h-9 text-xs';
  return (
    <div
      className={`${sizeCls} rounded-xl flex items-center justify-center font-semibold flex-shrink-0 num`}
      style={{ backgroundColor: c.bg, color: c.fg }}
      aria-hidden
    >
      {initials(account?.institution || account?.name || '?')}
    </div>
  );
}
